import {picdataLoaded, hitokotoLoadingError, loadPicdata} from 'containers/HomePage/actions';
import {put, takeLatest} from 'redux-saga/effects';
import {LOAD_PICDATA} from 'containers/HomePage/constants';

export function* getPicdata() {
  try {
    const res = yield fetch(
      new URL('./data.json',
        process.env.PUBLIC_PATH ?
          new URL(process.env.PUBLIC_PATH, `${location.protocol}//${location.host}/`).toString()
          : ''
      ).toString());
    const data = yield res.json();
    yield put(picdataLoaded(data));
  } catch (err) {
    yield put(hitokotoLoadingError(err));
  }
}

export default function* picData() {
  yield takeLatest(LOAD_PICDATA, getPicdata);
  yield put(loadPicdata());
}



// WEBPACK FOOTER //
// ./src/containers/HomePage/saga.ts